<template>
  <!--  @todo - see about implementing User Name and Logo  -->
  <!--    <v-toolbar flat class="pb-4 mb-4 tds-lhs-user-panel" @click="$emit('handleShowUserSettings')">-->
  <!--      <v-list two-line v-if="getPicture()">-->
  <!--        <v-list-tile avatar>-->
  <!--          <v-list-tile-avatar>-->
  <!--            <img :src="getPicture()" alt="Avatar" />-->
  <!--          </v-list-tile-avatar>-->
  <!--          <v-list-tile-content>-->
  <!--            <v-list-tile-title>{{getName()}}</v-list-tile-title>-->
  <!--            <v-list-tile-sub-title>{{getEmailAddress()}}</v-list-tile-sub-title>-->
  <!--          </v-list-tile-content>-->
  <!--        </v-list-tile>-->
  <!--      </v-list>-->
  <!--      <v-list two-line v-else>-->
  <!--        <v-list-tile>-->
  <!--          <v-list-tile-content class="tds-drawer-item-centered">-->
  <!--            <v-btn @click.stop="$emit('handleLogin')">Log in</v-btn>-->
  <!--          </v-list-tile-content>-->
  <!--        </v-list-tile>-->
  <!--      </v-list>-->
  <!--    </v-toolbar>-->
  <v-navigation-drawer app temporary absolute :value="showMainMenu" class="menu-container">
    <div class="menu-top-icon-container">
      <v-btn flat icon @click="handleCloseMainMenu">
        <v-icon class="menu-top-icon menu-top-icon-close">close</v-icon>
      </v-btn>
    </div>
    <v-list class="pt-0" dense>
      <DrawerOption
        v-for="(item, index) in drawerOptions"
        v-bind:key="index"
        v-bind:action="item.action || null"
        v-bind:icon="item.icon || null"
        v-bind:title="item.title || null"
        v-bind:isHighlighted="item.isHighlighted"
        v-bind:dividerFollows="item.dividerFollows || false"
        v-bind:isDivider="item.isDivider || false"
      >
      </DrawerOption>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import DrawerOption from '../DrawerOption'
import { getProfile } from '../../utils/auth'

import '../../style/_variables.scss'

export default {
  name: 'main-menu',
  props: ['drawerOptions'],
  components: {
    DrawerOption
  },
  computed: {
    showMainMenu: { get () { return this.$store.state.modalState.showMainMenu } }
  },
  methods: {
    handleCloseMainMenu () {
      this.$store.commit('setShowMainMenu', false)
    },
    getPicture () {
      const profile = getProfile()
      if (profile) {
        return profile.picture
      } else {
        return null
      }
    },
    getName () {
      const profile = getProfile()
      if (profile) {
        return profile.nickname
      } else {
        return null
      }
    },
    getEmailAddress () {
      const profile = getProfile()
      if (profile) {
        return profile.email
      } else {
        return null
      }
    }
  }
}
</script>

<style scoped lang="scss">
.menu-top-icon-container {
  flex-direction: row-reverse;
}
// Override
.theme--light .toolbar.tds-lhs-user-panel {
  background-color: $blue-grey-700;
  cursor: pointer;
}
.theme--light .tds-lhs-user-panel .list .list__tile__sub-title,
.theme--light .tds-lhs-user-panel .list .list__tile__title {
  color: white;
}
.list__tile__content.tds-drawer-item-centered {
  align-items: center;
}
.logout-btn-container {
  display: flex;
  align-content: center;
  flex-wrap: wrap;
}
</style>



// WEBPACK FOOTER //
// src/components/mainMenu/MainMenu.vue